var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('Error'):_c('div',{class:{
			pa5: _vm.$vuetify.breakpoint.smAndDown,
			palr5: _vm.$vuetify.breakpoint.mdAndUp,
		}},[_c('QuestionsRules',{attrs:{"questions":_vm.questionsRules}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }